(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(root) {
    root.querySelectorAll('[data-fr-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
    root.querySelectorAll('[data-fr-words] .fr-tagline__word').forEach(function (w) { w.classList.add('is-on'); });
  }

  function init(root) {
    root = root || document;
    if (reduce || !('IntersectionObserver' in window)) { revealAll(root); return; }

    var sections = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        sections.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });

    root.querySelectorAll('[data-fr-reveal]:not(.is-visible)').forEach(function (el) { sections.observe(el); });

    var words = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-on');
        words.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -40% 0px', threshold: 1 });

    root.querySelectorAll('[data-fr-words] .fr-tagline__word:not(.is-on)').forEach(function (w) { words.observe(w); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
